<template>
    <Message
        v-if="showBanner"
        severity="warn"
        :closable="true"
        @close="dismissed = true"
        class="mb-0"
    >
        <div class="flex items-center gap-2">
            <span>{{ t('billing.credits.low_balance_warning') }}</span>
            <button
                v-if="isTenantAdmin"
                type="button"
                class="underline font-semibold bg-transparent border-none cursor-pointer text-inherit p-0"
                @click="onTopupClick"
            >
                {{ t('billing.credits.low_balance_action') }}
            </button>
        </div>
    </Message>
    <BuyCreditsDialog v-model:visible="showBuyCreditsDialog" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import Message from 'primevue/message'
import { useBillingStore } from '@/stores/billing'
import { useTenantsStore } from '@/stores/tenants'
import { useFeaturesStore } from '@/stores/features'
import { isCreditPlan } from '@/models/Tenant'
import BuyCreditsDialog from '@/components/settings/billing/BuyCreditsDialog.vue'
import { useSelfServeGate } from '@/composables/useSelfServeGate'

const { t } = useI18n()
const billingStore = useBillingStore()
const tenantsStore = useTenantsStore()
const featuresStore = useFeaturesStore()
const { canSelfServeTopup, openContactSales } = useSelfServeGate()
const { isLowBalance } = storeToRefs(billingStore)

const dismissed = ref(false)
const showBuyCreditsDialog = ref(false)

// Self-serve gate (MYAC-837): route top-up to Contact sales unless allowed.
function onTopupClick() {
    if (canSelfServeTopup()) {
        showBuyCreditsDialog.value = true
        return
    }
    openContactSales('topup')
}

const isTenantAdmin = computed(() => featuresStore.isTenantAdmin)

const showBanner = computed(() => {
    if (dismissed.value) return false
    const plan = tenantsStore.currentTenant?.plan
    if (!plan || !isCreditPlan(plan)) return false
    return isLowBalance.value
})
</script>
